'use client';

import { useBreakpoint } from '@/shared/hooks/use-media-query';
import { cn } from '@/shared/lib/cn';

interface AccountPageContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component for account sub-pages
 * - On mobile: full background, constrained width (max-w-[720px])
 * - On desktop: no background/constraints (layout provides them)
 */
export function AccountPageContainer({
  children,
  className,
}: AccountPageContainerProps) {
  const { isLg } = useBreakpoint();

  if (isLg) {
    // Desktop: render children directly without wrapper
    return <div className={className}>{children}</div>;
  }

  // Mobile: full background with constrained width
  return (
    <div className={cn('bg-muted/40', className)}>
      <div className="max-w-[720px] mx-auto">{children}</div>
    </div>
  );
}
